// extracted by mini-css-extract-plugin
module.exports = {"header":"MicroCards_header__XjQoz","wrapper":"MicroCards_wrapper__uEbEa"};